import { CarEmergencyIcon } from './CarEmergencyIcon';

/**
 * author: GreenTurtwig
 * id 355D6842-8858-4C79-B684-0E0F5E03801D
 * name car-emergency
 * version: 5.6.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/car-emergency.svg
 * tags
 * - Transportation + Road 
 * - Automotive 
 */
export const CarPoliceIcon = CarEmergencyIcon;
export default CarPoliceIcon